import React from "react";

const defaultColumns = [
  "Registration no.",
  "Hub Station",
  "Start Energy",
  "End Energy",
];

const lendColumns = ["Registration no.", "Start Energy"];

const ColumnHeader = ({ type = "default" }) => {
  const columns = type === "lend" ? lendColumns : defaultColumns;

  return (
    <div className="flex items-center border-b-[0.5px] border-light-grey">
      {columns.map((item) => (
        <div key={item} className="flex-1 px-6 py-3 bg-background">
          <p className="font-aileron text-10 font-normal text-dark-gray">
            {item}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ColumnHeader;
